// 幫助中心用的小圖示（inline svg，顏色跟著 currentColor）

export const DocumentIcon = ({ size = 20 }: { size?: number }) => (
  <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden>
    <path
      d='M7 3h7l5 5v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinejoin='round'
    />
    <path d='M14 3v5h5M9 13h6M9 17h4' fill='none' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const ArrowRightIcon = ({ size = 18 }: { size?: number }) => (
  <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden>
    <path d='M5 12h14M13 6l6 6-6 6' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

export const ChatIcon = ({ size = 28 }: { size?: number }) => (
  <svg viewBox='0 0 24 24' width={size} height={size} aria-hidden>
    <path
      d='M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8l-5 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.7'
      strokeLinejoin='round'
    />
    <circle cx='8.5' cy='11' r='1.1' fill='currentColor' />
    <circle cx='12' cy='11' r='1.1' fill='currentColor' />
    <circle cx='15.5' cy='11' r='1.1' fill='currentColor' />
  </svg>
)
